import React, {PropTypes, Component} from 'react';
import {WithContext as ReactTags} from 'react-tag-input';
import Error from 'module-tsl-ui-components/es5/components/error/Error';
import {altFind, mergeArrays} from '../../lib/helpers';

const commaSeparatedTags = (tags) => tags.map((t) => t.text).join(',');

const arraysAreIdentical = (arr1, arr2) => {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;
  for (let i = 0, len = arr1.length; i < len; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
};

const transformTags = (tags) => tags.map((t, i) => ({id: i + 1, text: t}));

class TagInput extends Component {

  static propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    defaultTag: PropTypes.string,
    contentTags: PropTypes.array,
    suggestions: PropTypes.array,
    existingTags: PropTypes.string,
    suggestOnlyBaseTags: PropTypes.bool,
    meta: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const existingTags = [];
    if (this.props.defaultTag) {
      existingTags.push({id: 1, text: this.props.defaultTag});
    }

    if (this.props.existingTags) {
      existingTags.push(...this.props.existingTags.split(',').map((t, i) => ({id: i + 1, text: t})));
    }

    this.state = {
      tags: existingTags, // { id: 1, text: "sampletag" }
      suggestions: this.props.suggestions,
      manualTags: [],
    };

    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
  }

  componentWillMount() {
    this.props.input.onChange(commaSeparatedTags(this.state.tags));
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.contentTags) {
      return;
    }
    if (!arraysAreIdentical(nextProps.contentTags, this.props.contentTags)) {
      let tags = [];
      if (this.props.defaultTag) {
        tags.push(this.props.defaultTag);
      }

      if (this.props.existingTags) {
        tags = mergeArrays(tags, this.props.existingTags.split(','));
      }

      if (this.state.manualTags) {
        tags = mergeArrays(tags, this.state.manualTags.map((t) => t.text));
      }

      if (nextProps.contentTags) {
        tags = mergeArrays(tags, nextProps.contentTags);
      }

      this.setState({tags: transformTags(tags)});
      this.props.input.onChange(commaSeparatedTags(transformTags(tags)));
    }
  }

  handleDelete(i) {
    const tags = this.state.tags;
    tags.splice(i, 1);
    this.setState({tags});
    this.props.input.onChange(commaSeparatedTags(tags));
  }

  handleAddition(tag) {
    const manualTags = this.state.manualTags || [];
    const tags = this.state.tags;

    const result = altFind(manualTags, (e) => (e.text && e.text.toLowerCase() === tag.toLowerCase()));

    if (result) return;

    manualTags.push({
      id: manualTags.length + tags.length + 1,
      text: tag,
    });

    this.setState({manualTags});
    const mergedTags = transformTags(mergeArrays(tags.map((t) => t.text), manualTags.map((t) => t.text)));
    this.setState({tags: mergedTags});
    this.props.input.onChange(commaSeparatedTags(mergedTags));
  }

  render() {
    const {tags, suggestions} = this.state;
    const {label, meta: {touched, error: fieldError}} = this.props;

    const error = touched && fieldError ? fieldError : null;
    return (
      <div className="tes-form__group">
        <label htmlFor="tag-list" className="tes-control-label">{label}</label>
        <ReactTags
          id="tag-list"
          autofocus={false}
          placeholder=""
          tags={tags}
          suggestions={suggestions}
          handleDelete={this.handleDelete}
          handleAddition={this.handleAddition}
          minQueryLength={1}
          classNames={{
            tags: 'tag-picker',
            tagInput: 'tag-picker__control-wrapper',
            tagInputField: 'tes-control t-tes-control',
            selected: 'tag-selected',
            tag: 'tag margin-right-sm margin-bottom-xs t-tag',
            remove: 'tag-picker__remove-tag',
            suggestions: 'tag-picker__suggestions',
            activeSuggestion: 'tag-picker__suggestions--active',
          }}
        />
        <Error error={error} />
      </div>
    );
  }
}
export default TagInput;
